import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {makeMapDispatchToProps, makeMapStateToProps} from '../../helpers/reselectHelpers';
import {InboxModel} from '../../models/api/inboxModel';
import {SettingsInboxesUrl} from '../../models/url/settingsUrlModel';
import {AppState} from '../../store/appState';
import {ThunkAction} from '../../store/appThunk';
import {getFindHasCompanyFeature} from '../../store/data/company/companySelectors';
import {updateInboxAsyncAction} from '../../store/data/inboxes/inboxesActions';
import {getCalendarWeekStartDay, getTimeFormat} from '../../store/data/preferences/preferencesSelectors';
import {getTeamsByNamespace} from '../../store/data/teams/teamsSelectors';
import {navigateToLinkAction} from '../../store/stateless/navigationActions';
import {SettingsBusinessHours} from './settingsBusinessHours';

/*
 * Props.
 */

interface SettingsBusinessHoursContainerProps {
  url: SettingsInboxesUrl;
}

/*
 * Redux.
 */

function getNamespace(_state: AppState, props: SettingsBusinessHoursContainerProps) {
  return props.url.namespace;
}

const getInboxTeam = createSelector(
  [getTeamsByNamespace, getNamespace],
  (teamByNamespace, namespace) => teamByNamespace[namespace],
);

const mapStateToProps = makeMapStateToProps<SettingsBusinessHoursContainerProps>()(() => ({
  calendarWeekStartDay: getCalendarWeekStartDay,
  timeFormat: getTimeFormat,
  findHasCompanyFeature: getFindHasCompanyFeature,
  team: getInboxTeam,
}));

const mapDispatchToProps = makeMapDispatchToProps<SettingsBusinessHoursContainerProps>()(() => ({
  onSave:
    (inbox: InboxModel): ThunkAction =>
    (dispatch) => {
      dispatch(updateInboxAsyncAction(inbox));
    },
  navigateToLink: navigateToLinkAction,
}));

export const SettingsBusinessHoursContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SettingsBusinessHours);
